import { useState } from 'react';
import { BarChart3 } from 'lucide-react';

const ALLOW = { passing_yards: 'passing yds/g', passing_tds: 'passing TDs/g', rushing_yards: 'rushing yds/g', receiving_yards: 'passing yds/g', anytime_td: 'TDs/g' };

export const propWhy = (x) => {
  const s = x.stats || {};
  const out = [];
  if (s.season_avg != null) out.push(`Season: ${s.season_avg} ${x.label} per game over ${s.games} games`);
  if (s.last5?.length) out.push(`Last ${s.last5.length}: ${s.last5.join(', ')} (avg ${s.last5_avg})`);
  if (x.cushion) out.push(`Pick is set ${Math.round(x.cushion)} below the expected ${x.projection} so a slow game still clears it`);
  if (s.hits5 != null && s.last5?.length) out.push(`Cleared ${x.mark}+ in ${s.hits5} of the last ${s.last5.length} games`);
  if (s.hits != null && s.games) out.push(`Hit ${x.mark}+ in ${s.hits} of ${s.games} games (${Math.round((s.hits / s.games) * 100)}%)`);
  if (s.opp_allows != null) {
    const soft = s.league_avg_allowed != null && s.opp_allows > s.league_avg_allowed;
    out.push(`${x.opponent} defense allows ${s.opp_allows} ${ALLOW[x.stat]}${s.league_avg_allowed != null ? ` vs league avg ${s.league_avg_allowed} — ${soft ? 'softer matchup' : 'tougher matchup'}` : ''}`);
  }
  if (s.home != null) out.push(s.home ? 'Playing at home' : 'Playing on the road');
  (s.context || []).forEach((c) => out.push(c));
  out.push(`Model projects ${x.projection} → ${Math.round(x.prob * 100)}% chance of ${x.mark}+`);
  if (x.model_note) out.push(x.model_note);
  if (x.questionable) out.push('⚠ Injury news on this player — check status before kickoff');
  return out;
};

// Tap "Why it's safe" to see the stats behind a pick.
export default function WhySafe({ lines, testId, label = "Why it's safe" }) {
  const [open, setOpen] = useState(false);
  if (!lines?.length) return null;
  return (
    <div>
      <button type="button" onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }} data-testid={`${testId}-toggle`}
        className="mt-0.5 inline-flex items-center gap-1 text-[11px] font-semibold text-sky-300 hover:text-sky-200">
        <BarChart3 className="w-3 h-3" />{open ? 'Hide stats' : label}
      </button>
      {open && (
        <ul className="mt-1 space-y-0.5 rounded-md border border-sky-500/30 bg-sky-950/20 p-2" data-testid={`${testId}-lines`}>
          {lines.map((l) => <li key={l} className="text-[11px] text-zinc-300">• {l}</li>)}
        </ul>
      )}
    </div>
  );
}
